import { gtmDataLayerPush } from '../../gtm'
import { type CartIntermediateEntryObject } from '../model/CartIntermediateContextValue'

export const gtmDataLayerPushCartIntermediateBuyTogether = ({
  entries,
  prescriptionType,
}: {
  entries: CartIntermediateEntryObject[]
  prescriptionType: string
}): void => {
  const [originalOffer, recommendedOffer] = entries
  const products = entries.map((entry) => entry.product)

  const originalProduct = originalOffer.product
  const crossSellProduct = recommendedOffer.product

  if (!originalProduct || !crossSellProduct) {
    return
  }

  const originalPid = 'upid' in originalProduct ? originalProduct.upid : ''
  const crossSellPid = 'id' in crossSellProduct ? crossSellProduct.id : ''

  gtmDataLayerPush({
    cartAction: 'add',
    crossSellOfferId: recommendedOffer.id,
    crossSellPid,
    event: 'addToCart_bought_together',
    eventType: 'conversion',
    originalOfferId: originalOffer.id,
    originalPid,
    prescriptionType,
    products,
    quantity: 1,
  })
}
